import React, { Fragment, useEffect } from 'react';
import { Card, Col, Divider, Form, Icon, Row, Select, Switch, Tooltip } from 'antd';
import AddWarantyPolicy from './AddWarantyPolicy';
import AddProductType from './AddProductType';
import AddBrand from './AddBrand';
import { PRODUCT_CONDITION } from '../../../../utils/const';

const { Option } = Select;

let CURRENT_WARRANTY_PROLICY = null;

export default (props) => {

	const {
		productType,
		setProductType,
		brands,
		setBrands,
		warranties,
		setWarranties,
		guarantee,
		setGuarantee,
		status,
		setStatus
	} = props;

	const { getFieldDecorator } = props.form;

	const [showModalAddWarranty, setShowModalAddWarranty] = React.useState(false);
	const [showModalAddProductType, setShowModalAddProductType] = React.useState(false);
	const [showModalAddBrand, setShowModalAddBrand] = React.useState(false);

	useEffect(() => {
		setTimeout(() => {
			CURRENT_WARRANTY_PROLICY = props.form.getFieldValue('warrantyPolicyId');
		}, 1000);
	}, []);

	const renderOptions = (options) => options.map(el => <Option value={el.id} key={el.id}>{el.name}</Option>);

	const renderTitle = (title, tooltipContent) => {
		return <Fragment>
			<span>{title} <Tooltip title={tooltipContent}><Icon type="info-circle" /></Tooltip></span>
		</Fragment>;
	};

	useEffect(() => {
		if (guarantee && CURRENT_WARRANTY_PROLICY) {
			props.form.setFieldsValue({ 'warrantyPolicyId': CURRENT_WARRANTY_PROLICY });
		}
	}, [guarantee]);

	const warrantyPolicyChange = (value) => {
		setWarranties([...warranties, value]);
		props.form.setFieldsValue({ warrantyPolicyId: value.id });
	};

	return (
		<Fragment>
			<Card title="Thông tin bổ sung">
				<Row gutter={12}>
					<Col sm={24}>
						<Form.Item
							label={'Loại sản phẩm'}>
							{getFieldDecorator('productTypeId', {})(
								<Select allowClear placeholder={'Chọn loại sản phẩm'} dropdownRender={menu => (
									<div>
										{menu}
										<Divider style={{ margin: '4px 4px' }} />
										<div
											onClick={() => setShowModalAddProductType(true)}
											style={{ padding: '4px 4px', cursor: 'pointer', height: '34px' }}
											onMouseDown={e => e.preventDefault()}
										>
											<Icon type="plus" /> Thêm loại sản phẩm
										</div>
									</div>
								)}>
									{renderOptions(productType)}
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col sm={24}>
						<Form.Item label={'Tình trạng sử dụng'}>
							{getFieldDecorator('productCondition', { initialValue: 'NEW' })(
								<Select>
									{PRODUCT_CONDITION.map(el => <Option key={el.value}>{el.name}</Option>)}
								</Select>)}
						</Form.Item>
					</Col>
					<Col sm={24}>
						<Form.Item
							label={'Nhãn hiệu'}>
							{getFieldDecorator('brandId', {})(
								<Select allowClear placeholder={'Chọn nhãn dán'}
												dropdownRender={menu => (
													<div>
														{menu}
														<Divider style={{ margin: '4px 4px' }} />
														<div
															onClick={() => setShowModalAddBrand(true)}
															style={{ padding: '4px 4px', cursor: 'pointer', height: '34px' }}
															onMouseDown={e => e.preventDefault()}
														>
															<Icon type="plus" /> Thêm nhãn hiệu
														</div>
													</div>
												)}>
									{renderOptions(brands)}
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col sm={24}>
						<Form.Item
							label={renderTitle('Trạng thái', 'Cho phép tìm kiếm sản phẩm và tạo đơn hàng')}>
							<i>Có cho phép bán:
								{getFieldDecorator('status')(
									<Switch
										checked={status}
										onChange={(e) => setStatus(e)}
										style={{ marginLeft: '20px' }} />
								)}
							</i>
						</Form.Item>
					</Col>
					<Col sm={24}>
						<Form.Item
							label={'Bảo hành'}
							required={guarantee}
						>
							<i>Áp dụng bảo hành:
								<Switch style={{ marginLeft: '20px' }} checked={guarantee} onChange={(e) => setGuarantee(e)} />
							</i>
							{guarantee && getFieldDecorator('warrantyPolicyId',
								{
									rules: [{ required: true, message: 'Vui lòng chọn chính sách bảo hành' }]
								}
							)(
								<Select className={'mt-20'}
												allowClear
												placeholder={'Chọn chính sách bảo hành'}
												dropdownRender={menu => (
													<div>
														{menu}
														<Divider style={{ margin: '4px 4px' }} />
														<div
															onClick={() => setShowModalAddWarranty(true)}
															style={{ padding: '4px 8px', cursor: 'pointer' }}
															onMouseDown={e => e.preventDefault()}
														>
															<Icon type="plus" /> Thêm chính sách bảo hành
														</div>
													</div>
												)}
								>
									{renderOptions(warranties)}
								</Select>
							)}
						</Form.Item>
					</Col>
				</Row>
			</Card>
			<AddWarantyPolicy visible={showModalAddWarranty} setVisible={setShowModalAddWarranty}
												warrantyPolicyChange={warrantyPolicyChange} />
			<AddProductType visible={showModalAddProductType} setVisible={setShowModalAddProductType}
											callback={(value) => {
												setProductType([...productType, value]);
												props.form.setFieldsValue({ productTypeId: value.id });
											}} />
			<AddBrand visible={showModalAddBrand} setVisible={setShowModalAddBrand}
								callback={(value) => {
									setBrands([...brands, value]);
									props.form.setFieldsValue({ brandId: value.id });
								}} />
		</Fragment>
	);
};
